import { Mapper } from '@Features/utils/prepareSearchCriterias';
import { SearchItemOperator } from '@Types/api/common/filters';
import { TypeDict } from '@Types/index';

import { FilterForm } from './types';

export const initialValuesFilterForm: FilterForm = {
  dateFrom: '',
  dateTo: '',
  classifications: [],
  statuses: [],
};

export const filterTypes: Record<
  keyof typeof initialValuesFilterForm,
  SearchItemOperator
> = {
  dateFrom: 'ge',
  dateTo: 'le',
  classifications: 'in',
  statuses: 'in',
};

export const getFiltersMapper =
  (statuses: TypeDict[], classifications: TypeDict[]): Mapper =>
  (key, value) => {
    if (key === 'dateFrom') {
      return ['createdOn', value];
    }

    if (key === 'dateTo') {
      return ['createdOn', value];
    }

    if (key === 'classifications') {
      const classificationsResultValue = (value as string[]).map(
        (item) =>
          classifications.find(
            (classification) => classification.codeDesc === item
          )!.codeNum
      );
      return ['classificationId', classificationsResultValue];
    }

    const statusResultValue = (value as string[]).map(
      (item) => statuses.find((status) => status.codeDesc === item)!.codeNum
    );
    return ['statusId', statusResultValue];
  };
